import React from "react";
import { ChevronDownIcon } from "./svgIcons";

const LeftSection = ({
  proposalData,
  expandedSections,
  activeRightSection,
  toggleSection,
  handleSectionSelect,
  handleOpenAssignModal,
  getInitials,
  userPermission,
}) => {
  const canAssign = userPermission !== "reviewer" && userPermission !== "editor";

  return (
    <div className="w-[65%] flex flex-col bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="flex-1 overflow-y-auto p-6 custom-scrollbar">
        <h1 className="text-[#18101C] !font-outfit text-2xl font-semibold mb-6">
          {"Sections in this Proposal"}
        </h1>

        {proposalData?.proposal_content?.map((section, sectionIdx) => (
          <div key={sectionIdx} className="mb-6 font-outfit">
            <div className="flex items-center justify-between !font-outfit mb-3">
              <div
                className="flex items-center gap-3 cursor-pointer group flex-1"
                onClick={() => handleSectionSelect(section)}
              >
                <h2
                  className={`text-xl font-medium transition-colors ${
                    activeRightSection?.id === section.id ||
                    activeRightSection?.section_id === section.section_id
                      ? "text-[#C95EBE]"
                      : "text-[#18101C] group-hover:text-[#C95EBE]"
                  }`}
                >
                  {section.number}. {section.title}
                </h2>

                {/* Arrow Icon */}
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleSection(`section-${sectionIdx}`);
                  }}
                  className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <ChevronDownIcon
                    className={`transform transition-transform ${
                      expandedSections[`section-${sectionIdx}`]
                        ? "rotate-180"
                        : ""
                    }`}
                  />
                </div>

                {/* Avatar Group */}
                {section.assigned_members &&
                  section.assigned_members.length > 0 && (
                    <div className="flex items-center -space-x-2 ml-1">
                      {section.assigned_members
                        .slice(0, 4)
                        .map((member, mIdx) => (
                          <div
                            key={mIdx}
                            className="w-7 h-7 rounded-full bg-[#C95EBE] border-2 border-white text-white flex items-center justify-center text-[10px] font-medium"
                            title={member.full_name || member.email}
                          >
                            {getInitials(member.full_name || member.email)}
                          </div>
                        ))}
                      {section.assigned_members.length > 4 && (
                        <div className="w-7 h-7 rounded-full bg-gray-100 border-2 border-white text-[#6B7280] flex items-center justify-center text-[10px] font-medium">
                          +{section.assigned_members.length - 4}
                        </div>
                      )}
                    </div>
                  )}
              </div>

              {canAssign && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenAssignModal(
                      sectionIdx,
                      section.title,
                      section.section_id || section.id
                    );
                  }}
                  className="text-[#404040] font-outfit text-[15px] font-medium hover:text-[#BB42AE] transition-colors whitespace-nowrap"
                >
                  Assign Section
                </button>
              )}
            </div>

            {expandedSections[`section-${sectionIdx}`] && (
              <div className="pl-4 border-l-2 border-[#E5E7EB]">
                {section.response && section.response.trim() !== "" && (
                  <p className="text-[#374151] font-outfit text-base mb-4 leading-relaxed">
                    {section.response}
                  </p>
                )}
                {section.children && section.children.length > 0 && (
                  <div className="space-y-4">
                    {section.children.map((child, childIdx) => (
                      <div key={childIdx} className="ml-4">
                        <h3 className="text-[#374151] font-outfit text-lg font-medium mb-2">
                          {child.number} {child.title}
                        </h3>
                        {child.response && child.response.trim() !== "" ? (
                          <p className="text-[#4B5563] font-outfit text-base leading-relaxed">
                            {child.response}
                          </p>
                        ) : (
                          <p className="text-[#9CA3AF] font-outfit text-base italic">
                            No content available
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}

        {(!proposalData?.proposal_content ||
          proposalData.proposal_content.length === 0) && (
          <div className="text-center py-12">
            <p className="text-[#9CA3AF] font-outfit text-lg">
              No proposal content available
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftSection;
